import { FEATURES } from '../../config/features';

export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path === '/' && FEATURES.isBaseSpecial) {
    return navigateTo('/start');
  }

  if (to.path === '/demo' && !FEATURES.demo) {
    return navigateTo('/');
  }

  const isGuardedRoutes = to.path.includes('/team')
    || to.path.includes('/rules')
    || to.path.includes('/message')
    || to.path.includes('/35');

  if (isGuardedRoutes && (!from || !from.name)) {
    return navigateTo('/start');
  }

  const allowedRoutes = [
    '/start',
    '/message',
    '/35',
    '/team',
    '/rules',
    '/prizes',
  ];

  if (!allowedRoutes.includes(to.path) && (!from || !from.name)) {
    return navigateTo('/start');
  }
});
